module.exports = __webpack_public_path__ + "7575030a72b7bb7b43cc6ff9a867d66b.svg";